export const MEMBER = "Član-67ecec9a6ba82";